import { create } from "zustand";
import { getFromLocalStorage, setInLocalStorage } from "../services/localStorageGetSet";

type State = {
  collapse: boolean;
};

type Action = {
  updateCollapse: (newToken: State['collapse']) => void;
};

export const useMenu = create<State & Action>((set) => ({
  collapse: Number(getFromLocalStorage('collapse')) === 1,
  updateCollapse: (newToken: boolean) => set(() => {
    setInLocalStorage('collapse', Number(newToken));

    return { collapse: newToken };
  })
}));
